// SPA helpers for the Google tag already loaded in public/index.html.
// Do not inject a second gtag.js script — Google allows one tag per page.

const MEASUREMENT_ID = "G-SFQS8VSNJM";
const CONSENT_STORAGE_KEY = "novtia-analytics-consent";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function gtag(...args: unknown[]): void {
  if (typeof window.gtag === "function") {
    window.gtag(...args);
    return;
  }
  // Fallback before the HTML tag finishes defining window.gtag.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

/** Returns the stored choice, or null if the visitor has not decided yet. */
export function getStoredConsent(): boolean | null {
  try {
    const stored = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (stored === "granted") return true;
    if (stored === "denied") return false;
    return null;
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(granted: boolean): void {
  try {
    window.localStorage.setItem(
      CONSENT_STORAGE_KEY,
      granted ? "granted" : "denied"
    );
  } catch {
    // Storage unavailable — apply for this session only.
  }

  gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
  });
}

/**
 * The base Google tag is in index.html. This only syncs any stored consent
 * choice after the app mounts.
 */
export function initAnalytics(): void {
  if (getStoredConsent() === true) {
    gtag("consent", "update", { analytics_storage: "granted" });
  }
}

/** Send a page_view for React Router navigations (SPA). */
export function trackPageView(path: string, title?: string): void {
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
    send_to: MEASUREMENT_ID,
  });
}

export function trackEvent(
  name: string,
  params?: Record<string, unknown>
): void {
  gtag("event", name, params ?? {});
}
